import { TenantDashboard } from 'app/library/tenant-dashboard/models/tenant-dashboard';
import { IProgramExecutionMetricsQuery } from '../interfaces/program-execution-metrics.query.interface';

// @dynamic
export class ProgramExecutionMetrics {
    totalParticipantCount: number;
    charts: TenantDashboard[];

    constructor(query: IProgramExecutionMetricsQuery) {
        this.totalParticipantCount = query.total_participant_count;
        this.charts = query.charts ? query.charts.map((chart) => new TenantDashboard(chart)) : [];
    }
}
